stripBasename